module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "sert"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _vm._v("Chicago Studies in American Politics")]), _vm._v(" "), _c('p', {
    staticClass: "sers"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SERIES")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EDITED")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BY")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BENJAMIN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("I.")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("PAGE,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SUSAN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HERBST,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LAWRENCE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("R.")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("JACOBS,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ADAM")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("J.")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BERINSKY")])]), _vm._v(" "), _c('p', {
    staticClass: "serah"
  }, [_c('i', [_vm._v("Also in the series:")])]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "sm"
  }, [_vm._v("TRAPPED")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AMERICA’S")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SAFETY")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("NET:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ONE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("FAMILY’S")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("STRUGGLE")]), _vm._v(" by "), _c('i', [_vm._v("Andrea Louise Campbell")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ARRESTING")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CITIZENSHIP:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DEMOCRATIC")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CONSEQUENCES")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AMERICAN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CRIME")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CONTROL")]), _vm._v(" by "), _c('i', [_vm._v("Amy E. Lerman and Vesla M. Weaver")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("HOW")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("STATES")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SHAPED")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("NATION:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AMERICAN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ELECTORAL")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("INSTITUTIONS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("VOTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("TURNOUT,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("1920–2000")]), _vm._v(" by "), _c('i', [_vm._v("Melanie Jean Springer")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AMERICAN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("WARFARE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("STATE:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DOMESTIC")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("POLITICS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MILITARY")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SPENDING")]), _vm._v(" by "), _c('i', [_vm._v("Rebecca U. Thorpe")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHANGING")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MINDS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OR")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CHANGING")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CHANNELS?")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("PARTISAN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("NEWS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AGE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CHOICE")]), _vm._v(" by "), _c('i', [_vm._v("Kevin Arceneaux and Martin Johnson")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("TRADING")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DEMOCRACY")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("FOR")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("JUSTICE:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CRIMINAL")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CONVICTIONS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DECLINE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("NEIGHBORHOOD")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("POLITICAL")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("PARTICIPATION")]), _vm._v(" by "), _c('i', [_vm._v("Traci Burch")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("WHITE-COLLAR")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("GOVERNMENT:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HIDDEN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ROLE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CLASS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ECONOMIC")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("POLICY")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MAKING")]), _vm._v(" by "), _c('i', [_vm._v("Nicholas Carnes")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("HOW")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("PARTISAN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MEDIA")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("POLARIZE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AMERICA")]), _vm._v(" by "), _c('i', [_vm._v("Matthew Levendusky")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("POLITICS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BELONGING:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("RACE,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("PUBLIC")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OPINION,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IMMIGRATION")]), _vm._v(" by "), _c('i', [_vm._v("Natalie Masuoka and Jane Junn")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("POLITICAL")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("TONE:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HOW")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LEADERS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("TALK")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("WHY")]), _vm._v(" by "), _c('i', [_vm._v("Roderick P. Hart, Jay P. Childers, and Colene J. Lind")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("TIMELINE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("PRESIDENTIAL")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ELECTIONS:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HOW")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CAMPAIGNS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("(AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("NOT)")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MATTER")]), _vm._v(" by "), _c('i', [_vm._v("Robert S. Erikson and Christopher Wlezien")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("LEARNING")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("WHILE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("GOVERNING:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EXPERTISE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ACCOUNTABILITY")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EXECUTIVE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BRANCH")]), _vm._v(" by "), _c('i', [_vm._v("Sean Gailmard and John W. Patty")])]), _vm._v(" "), _c('p', {
    staticClass: "serah"
  }, [_c('a', {
    staticClass: "page"
  }), _c('a', {
    attrs: {
      "href": "#/chidruckmanjacobs0023"
    }
  }, [_c('i', [_vm._v("Additional series titles follow the index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36149a0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-druckman-jacobs-0003.vue
// module id = 60
// module chunks = 0